
import React from 'react'
import AssetcyclePrint from '../../components/assetlifecyclecomponents/AssetcyclePrint'
function  Fileassetlife({renderPageContent}) {
    return (
        <>
                        <AssetcyclePrint  renderPageContent={renderPageContent}/>
        </>
    )
}

export default Fileassetlife
